import React, { Fragment, useEffect, useState } from "react";
import "./App.css";

import JsonFileImport from "./components/json-connector/file";
import FormUrl from "./components/json-connector/url";
import { Divider, Table, Radio, Checkbox, Switch, message, Button } from "antd";
import { IoText } from "react-icons/io5";
import { TiSortNumerically } from "react-icons/ti";
import { FcOvertime } from "react-icons/fc";
import { FaPercentage } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import { ApiGetData, ApiFormat, ApiDataSource } from "./host";
export default function App() {
  const [raw, setRaw] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [extract, setExtract] = useState(false);
  const [url, setUrl] = useState("");
  const [data, setData] = useState([]);
  const [value, setValue] = useState(true);
  const [param, setParam] = useState([]);
  const options = [
    { label: "via un fichier json", value: true },
    { label: "via une Api", value: false },
  ];
  const [checked, setChecked] = useState(true);
  const [initialRows, setInitialRows] = useState(false);
  const columns = [
    {
      title: "Colonne",
      width: 100,
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: "Indicateur",
      width: 50,
      render: (e) => {
        return (
          <Switch
            optiontype="button"
            buttonstyle="solid"
            checked={e.isIndicator}
            onChange={() => setIndicator(value, e)}
          />
        );
      },
    },
    {
      title: "Type",
      width: 100,
      key: "type",
      render: (e) => {
        return (
          <Radio.Group
            options={[
              { value: 1, label: <TiSortNumerically /> },
              { value: 2, label: <IoText /> },
              { value: 3, label: <FcOvertime /> },
              { value: 4, label: <FaPercentage /> },
            ]}
            onChange={(value) => setDataType(value, e)}
            value={e.type}
            optionType="button"
            buttonStyle="solid"
          />
        );
      },
    },
    {
      title: "Ignorer",
      key: "ignored",
      width: 80,
      render: (e) => {
        return (
          <Checkbox
            onChange={() => setCheck(value, e)}
            defaultChecked={e.ignored}
            checked={e.ignored}
          />
        );
      },
    },
  ];

  const setIndicator = (value, e) => {
    if ((e.type === 1 || e.type === 4) && e.ignored === false) {
      const newData = data.map((d) => {
        if (d.name === e.name) d.isIndicator = !d.isIndicator;
        return d;
      });
      setData(newData);
    } else {
      message.info("Un indicateur ne peut être qu'un nombre ou un pourcentage");
    }
  };
  const setCheck = (value, e) => {
    const newData = data.map((d) => {
      if (d.name === e.name) d.ignored = !d.ignored;
      return d;
    });
    setData(newData);
  };
  const setDataType = (value, e) => {
    const newData = data.map((d) => {
      if (d.name === e.name) {
        d.type = value.target.value;
        if (!(d.type === 1 || d.type === 4)) d.isIndicator = false;
      }
      return d;
    });
    setData(newData);
  };
  useEffect(() => {
    if (Array.isArray(raw) && raw.length > 0) {
      const row = raw[0];
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const body = JSON.stringify(row);

      const requestOptions = {
        method: "post",
        headers: myHeaders,
        mode: "cors",
        body: body,
        redirect: "follow",
      };
      fetch(ApiFormat, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          setData(JSON.parse(result));

          message.success("Les données ont été recupérer avec succès");
        })
        .catch((error) => {
          message.error(
            "Une erreur est survenue lors de la récupération des données"
          );
          console.log("error", error);
        });
    } else {
      // console.log(typeof raw);
      if (typeof raw === "object" && !Array.isArray(raw))
        message.error(
          "le format des données est incorrecte, veuillez entrer un tableau d'objet"
        );
    }
  }, [raw]);

  const onChange = ({ target }) => {
    setValue(target.value);
  };
  const callBack = (data, status) => {
    window.parent.postMessage(
      JSON.stringify({ data, status, id: new Date().getTime() }),
      "*"
      // "http://localhost:3000"
      // "https://viabber-dev.web.app"
      // "https://viabber-new-design.web.app"
      // "https://testenv.viabber.com"
    );
    // console.log("data send : ", data);
  };
  const extractData = () => {
    // console.log(value);
    const filtered = data.filter((d) => d.ignored === false);
    const indicateur = filtered.filter((d) => d.isIndicator === true);
    const date = filtered.filter((d) => d.type === 3);
    if (!(Array.isArray(indicateur) && indicateur.length >= 1)) {
      message.info("Minimum une colonne doit être de indicateur");
      return;
    }
    if (!(Array.isArray(date) && date.length >= 1)) {
      message.info("Minimum une colonne doit être de type date");
      return;
    }
    const nodes = filtered.map((d, index) => {
      return {
        name: d.name,
        index: index,
        tag: d.name,
        dataType: d.type,
        columnType: d.type === 1 ? "indicator" : "dimension",
      };
    });
    setExtract(true);
    if (!value) {
      const newData = {
        url: url,
        method: param.method,
        token: "",
        content: param.content ? param.content : null,
        callback: "",
        operation: "1",
        redirection: "",
        contentType: param.contentType ? param.content : null,
        headers: param.headers ? param.headers : null,
        nodes: nodes,
        initialRows: initialRows,
      };
      console.log(newData);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const jsondata = JSON.stringify(newData);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: jsondata,
        redirect: "follow",
      };
      // console.log(newData);
      fetch(ApiDataSource, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const resultat = JSON.parse(result);
          // console.log(resultat);
          // console.log(resultat);
          const requestOptions = {
            method: "GET",
            redirect: "follow",
          };
          fetch(resultat.url, requestOptions)
            .then((response) => response.text())
            .then((result) => {
              const response = JSON.parse(result);
              response["url"] = resultat.url;
              callBack(response, 200);
              // console.log(response);
              message.success("Les données ont été extraites avec succes");
              setExtract(false);
              // setIsLoading(false);
            })
            .catch((error) => {
              message.error(
                "une erreur est survenue lors de l'extraction des données"
              );
              console.log("error", error);
            });
        })
        .catch((error) => {
          message.error(
            "une erreur est survenue lors de l'insertion des données"
          );
          console.log("error", error);
          setExtract(false);
        });
    } else {
      // message.info("cette fonctionnalité n'est pas disponible");
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const body = JSON.stringify({
        raw: raw,
        columns: nodes,
      });
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: body,
        redirect: "follow",
      };

      fetch(ApiGetData, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const response = JSON.parse(result);
          // console.log(response);
          callBack(response, 200);
          setExtract(false);
        })
        .catch((error) => {
          message.error(
            "une erreur est survenue lors de l'extraction des données"
          );
          console.log("error", error);
          setExtract(false);
        });
      setExtract(false);
    }
  };
  return (
    <div className="App" style={{ width: "80%", margin: "2% auto" }}>
      <div style={{ marginBottom: "4%" }}>
        <Radio.Group
          options={options}
          onChange={onChange}
          value={value}
          optionType="button"
          buttonStyle="solid"
        />
      </div>

      {value ? (
        <JsonFileImport
          setRaw={setRaw}
          loading={loading}
          setLoading={setLoading}
          Loading={setIsLoading}
        />
      ) : (
        <FormUrl
          setRaw={setRaw}
          loading={loading}
          setLoading={setLoading}
          url={url}
          setUrl={setUrl}
          setParam={setParam}
          Loading={setIsLoading}
        />
      )}
      <Divider />
      {isLoading ? (
        <ClipLoader
          color={"#1890ff"}
          loading={isLoading}
          size={45}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <Fragment>
          <Table
            rowKey="name"
            bordered={false}
            columns={columns}
            dataSource={data}
            pagination={false}
            scroll={{ x: 700 }}
            locale={{ emptyText: "Aucune donnée" }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {!value && (
              <Checkbox
                style={{
                  fontSize: 16,
                  fontFamily: "Inter",
                  marginTop: "2px",
                  alignSelf: "flex-start",
                }}
                onChange={(e) => {
                  setChecked(e.target.checked);
                  setInitialRows(!e.target.checked);
                }}
                checked={checked}
              >
                {"  "}
                Récuperation des données de façon asynchrone
              </Checkbox>
            )}
            <Button
              type="primary"
              style={{
                alignItems: "center",
                width: "30%",
                marginTop: !value ? "2px" : "30px",
                minWidth: "150px",
                textAlign: "center",
              }}
              onClick={extractData}
              disabled={data.length === 0 ? true : false}
              loading={extract}
            >
              Extraire les données
            </Button>
          </div>
        </Fragment>
      )}
    </div>
  );
}
